export enum PresetDate {
  TRAILING_WEEK = 'TRAILING_WEEK',
  TRAILING_MONTH = 'TRAILING_MONTH',
  TRAILING_THREE_MONTHS = 'TRAILING_THREE_MONTHS',
}

// Global constants for Training List components
export const ALL_FILTER_VALUE = 'ALL';

// Filter selection enums
export enum CcxMetricFilter {
  ALL = 'ALL',
  EMPATHY = 'Empathy',
  COURTESY = 'Courtesy',
  KNOWLEDGE_LEVEL = 'Knowledge level',
  UNDERSTANDABILITY = 'Understandability',
  HELPFULNESS = 'Helpfulness',
  EFFICIENCY = 'Efficiency',
}

export enum TrainingStatusFilter {
  ALL = 'ALL',
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  OVERDUE = 'Overdue',
  COMPLETED = 'Completed',
}

export const trainingResultsPerPage = [5, 10, 15, 20];

export enum TrainingViewMode {
  TM = 'TM',
  CSA = 'CSA',
}
